import { Spinner } from '@mcgames/ui';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useSession } from '../api/auth-store.ts';
import { ForbiddenPage } from '../pages/ForbiddenPage.tsx';

/** Admin area gate: wait for the session restore, send visitors to /login, refuse non-admins. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const session = useSession();
  if (session.status === 'restoring') return <Spinner />;
  if (session.status === 'anonymous') return <Navigate to="/login" replace />;
  if (session.user.role !== 'admin') return <ForbiddenPage />;
  return children;
}
